<template>
    <b-container fluid>
        <b-container class="p-4 dashboardTile shadow-lg">
            <b-row v-if="group" class="p-2">
            <b-col cols="12" md="6" class="my-auto">
                <b-row>
                    <b-col cols="12" class="text-center">
                        <h4>{{$t('prepaid.group.actions')}}</h4>
                    </b-col>
                </b-row>
                <b-row class="flex-center">
                    <b-col cols="12" class="py-2">
                        <b-btn v-b-modal.editGroup class="float-right w-100"><span class="fa fa-edit mx-2"></span> {{$t('prepaid.group.buttons.edit')}}</b-btn>
                    </b-col>
                    <b-col cols="12" class="py-2">
                        <b-btn v-b-modal.deleteGroup @click="" variant="danger" class="float-right w-100"><span class="fa fa-print mx-2"></span> {{$t('prepaid.group.buttons.delete')}}</b-btn>
                    </b-col>
                    <b-col cols="12" class="py-2">
                        <b-btn v-b-modal.generateCard variant="primary" class="float-right w-100"><span class="fa fa-ticket-alt mx-2"></span> {{$t('prepaid.group.buttons.generate')}}</b-btn>
                    </b-col>
                </b-row>
            </b-col>
            <b-col cols="12" md="6" class="noSectorDash p-2 my-auto">
                <h4 class="text-center"> {{ group.name }} </h4>
                <h6 class="flex-center mx-2">{{$t('prepaid.group.card.from')}}: {{ group.date_from | moment('DD.MM.YYYY')}} - {{$t('prepaid.group.card.to')}}: {{ group.date_to | moment('DD.MM.YYYY')}}</h6>
                <h5 class=" flex-center mx-2">{{$t('prepaid.group.card.cardNo')}}: {{ prepaidCards.length }}</h5>
            </b-col>
        </b-row>

        </b-container>

        <hr/>

        <b-container class="p-4 dashboardTile shadow-lg">
            <b-row v-if="prepaidCards" class="py-2">
            <b-col>
                <events-table position
                              search-key="full_name"
                              :items="prepaidCards"
                              :fields="cardFields"
                              :actions="actions"
                              @action="action">
                </events-table>
            </b-col>
        </b-row>

        </b-container>
        



        <b-modal centered
                 no-close-on-backdrop
                 id="editGroup"
                 title=""
                 hide-footer>
                 <template v-slot:modal-title>
                    {{$t('prepaid.group.card.modal.edit.title')}}
                </template>
            <b-form @submit.prevent="editGroup()" data-vv-scope="editGroup">

                <b-row>
                    <b-col cols="12">
                        <b-form-group label-for="groupName">{{$t('prepaid.modal.name')}}
                            <b-form-input :state="validateState('editGroup.groupName')"
                                          :class="{'is-invalid': veeErrors.has('editGroup.groupName')}"
                                          v-model="group.name" v-validate="'required|min:6'" id="groupName" ref="groupName" type="text" size="md" name="groupName"></b-form-input>
                            <span class="vvError">{{ veeErrors.first('editGroup.groupName') }}</span>
                        </b-form-group>
                    </b-col>

                    <b-col cols="6">
                        <b-form-group label-for="date_from">{{$t('prepaid.modal.from')}}
                            <date-picker format="YYYY-MM-DD HH:mm:ss"
                                         name="dateFrom"
                                         v-validate="'required'"
                                         v-model="group.date_from"
                                         :not-before="new Date()"
                                         :not-after="group.date_to"
                                         :lang="$parent[$i18n.locale]"
                                         type="datetime"
                                         :minute-step="10"
                                         :first-day-of-week="1"
                                         class="w-100"
                                         id="date_from">
                            </date-picker>
                            <span class="vvError">{{ veeErrors.first('editGroup.date_from') }}</span>
                        </b-form-group>
                    </b-col>

                    <b-col cols="6">
                        <b-form-group label-for="date_to">{{$t('prepaid.modal.to')}}
                            <date-picker format="YYYY-MM-DD HH:mm:ss"
                                         name="dateFrom"
                                         v-validate="'required'"
                                         v-model="group.date_to"
                                         :not-before="new Date() || group.date_from"
                                         :lang="$parent[$i18n.locale]"
                                         type="datetime"
                                         :minute-step="10"
                                         :first-day-of-week="1"
                                         class="w-100"
                                         id="date_to">
                            </date-picker>
                            <span class="vvError">{{ veeErrors.first('editGroup.date_to') }}</span>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12" class="text-center">
                        <b-btn type="submit" :disabled="veeErrors.any('editGroup')" ref="btnEdit" variant="primary" class="w-50">{{$t('prepaid.group.card.modal.edit.title')}}</b-btn>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>

        <b-modal centered
                 no-close-on-backdrop
                 id="generateCard"
                 title=""
                 hide-footer>
                  <template v-slot:modal-title>
                    {{$t('prepaid.group.card.modal.generate.title')}}
                </template>
            <b-col md="12">
                <b-form @submit.prevent="generateCard()" data-vv-scope="generateCard">
                    <b-row>

                        <b-col cols="6" class="flex-center">
                            <h5>{{ group.name }}</h5>
                        </b-col>

                        <b-col cols="6">
                            <b-form-group label-for="prepaidGroup">{{$t('prepaid.group.card.modal.generate.pg')}}
                                <b-form-input :state="validateState('generateCard.prepaidGroup')"
                                              :class="{'is-invalid': veeErrors.has('generateCard.prepaidGroup')}"
                                              v-validate="'required|min_value:1'" v-model="group.id"
                                              id="prepaidGroup" ref="prepaidGroup" type="number" size="md" name="prepaidGroup" disabled></b-form-input>
                                <span class="vvError">{{ veeErrors.first('generateCard.prepaidGroup') }}</span>
                            </b-form-group>
                        </b-col>

                        <b-col cols="6">
                            <b-form-group label-for="fullName">{{$t('prepaid.group.card.modal.generate.name')}}
                                <b-form-input :state="validateState('generateCard.fullName')"
                                              :class="{'is-invalid': veeErrors.has('generateCard.fullName')}"
                                              v-model="card.full_name" v-validate="'required|min:6'" id="fullName" ref="fullName" type="text" size="md" name="fullName"></b-form-input>
                                <span class="vvError">{{ veeErrors.first('generateCard.fullName') }}</span>
                            </b-form-group>
                        </b-col>

                        <b-col cols="6">
                            <b-form-group label-for="dob">{{$t('prepaid.group.card.modal.generate.dob')}}
                                <date-picker format="YYYY-MM-DD HH:mm:ss"
                                             name="dob"
                                             v-validate="'required'"
                                             v-model="card.dob"
                                             :not-after="new Date()"
                                             :lang="$parent[$i18n.locale]"
                                             type="datetime"
                                             :minute-step="10"
                                             :first-day-of-week="1"
                                             class="w-100"
                                             id="dob">
                                </date-picker>
                                <span class="vvError">{{ veeErrors.first('generateCard.dob') }}</span>
                            </b-form-group>
                        </b-col>

                        <b-col cols="6">
                            <b-form-group label-for="description">{{$t('prepaid.group.card.modal.generate.desc')}}
                                <b-form-input :state="validateState('generateCard.description')"
                                              :class="{'is-invalid': veeErrors.has('generateCard.description')}"
                                              v-model="card.desc" v-validate="'required|min:6'" id="description" ref="description" type="text" size="md" name="description"></b-form-input>
                                <span class="vvError">{{ veeErrors.first('generateCard.description') }}</span>
                            </b-form-group>
                        </b-col>

                        <b-col cols="6">
                            <b-form-group label-for="phone">{{$t('prepaid.group.card.modal.generate.num')}}
                                <b-form-input :state="validateState('generateCard.phone')"
                                              :class="{'is-invalid': veeErrors.has('generateCard.phone')}"
                                              v-model="card.phone" v-validate="'required|min:6'" id="phone" ref="phone" type="text" size="md" name="phone"></b-form-input>
                                <span class="vvError">{{ veeErrors.first('generateCard.phone') }}</span>
                            </b-form-group>
                        </b-col>

                        <b-col cols="6">
                            <b-form-group label-for="cardCode">{{$t('prepaid.group.card.modal.generate.code')}}
                                <b-form-input :state="validateState('generateCard.cardCode')"
                                              :class="{'is-invalid': veeErrors.has('generateCard.cardCode')}"
                                              v-model="card.code" v-validate="'required|alpha_num'" id="cardCode" ref="cardCode" type="text" size="md" name="cardCode"></b-form-input>
                                <span class="vvError">{{ veeErrors.first('generateCard.cardCode') }}</span>
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <b-form-group label-for="cardCode2">{{$t('prepaid.group.card.modal.generate.code2')}}
                                <b-form-input :state="validateState('generateCard.cardCode2')"
                                              :class="{'is-invalid': veeErrors.has('generateCard.cardCode2')}"
                                              v-model="card.code2" v-validate="'required|alpha_num'" id="cardCode2" ref="cardCode2" type="text" size="md" name="cardCode2"></b-form-input>
                                <span class="vvError">{{ veeErrors.first('generateCard.cardCode2') }}</span>
                            </b-form-group>
                        </b-col>

                        <b-col cols="4">
                            <b-form-group label-for="prefSector">{{$t('prepaid.group.card.modal.generate.sector')}}
                                <b-form-select v-model="card.pref_sector_id" name="prefSector" v-validate="'required|alpha_num'">
                                    <option v-for="sector in sectors" :value="sector.id">{{sector.code}}</option>
                                </b-form-select>
                                <span class="vvError">{{ veeErrors.first('generateCard.prefSector') }}</span>
                            </b-form-group>
                        </b-col>

                        <b-col cols="4">
                            <b-form-group label-for="prefRow"
                                          v-for="sector in sectors"  v-if="sector.id === card.pref_sector_id">{{$t('prepaid.group.card.modal.generate.row')}}
                                <b-form-input :state="validateState('generateCard.prefRow')"
                                              :class="{'is-invalid': veeErrors.has('generateCard.prefRow')}"
                                              v-model.number="card.pref_row" v-validate="'required|min_value:1|max_value:'+sector.rows" id="prefRow" ref="prefRow" type="number" size="md" name="prefRow"></b-form-input>
                                <b-form-text id="row-help-block" v-for="sector in sectors" v-if="sector.id === card.pref_sector_id">
                                    {{$t('prepaid.group.card.modal.generate.of')}} {{ sector.rows }}
                                </b-form-text>
                                <span class="vvError">{{ veeErrors.first('generateCard.prefRow') }}</span>
                            </b-form-group>
                        </b-col>

                        <b-col cols="4">
                            <b-form-group label-for="prefSeat"
                                          v-for="sector in sectors"  v-if="sector.id === card.pref_sector_id">{{$t('prepaid.group.card.modal.generate.seat')}}
                                <b-form-input :state="validateState('generateCard.prefSeat')"
                                              :class="{'is-invalid': veeErrors.has('generateCard.prefSeat')}"
                                              v-model.number="card.pref_seat" v-validate="'required|min_value:1|max_value:'+sector.row_seats" id="prefSeat" ref="prefSeat" type="number" size="md" name="prefSeat"></b-form-input>
                                <b-form-text id="seat-help-block" v-for="sector in sectors" v-if="sector.id === card.pref_sector_id">
                                    {{$t('prepaid.group.card.modal.generate.of')}} {{ sector.row_seats }}
                                </b-form-text>
                                <span class="vvError">{{ veeErrors.first('generateCard.prefSeat') }}</span>
                            </b-form-group>
                        </b-col>



                    </b-row>
                    <b-row class="float-right">
                        <b-button type="submit" variant="primary" ref="btnGenerate" :disabled="veeErrors.any('generateCard')">{{$t('prepaid.group.card.modal.generate.button')}}</b-button>
                    </b-row>
                </b-form>
            </b-col>
        </b-modal>

        <b-modal centered
                 id="deleteGroup"
                 title=""
                 @ok="deleteGroup"
                 ok-variant="danger">
                 <template v-slot:modal-title>
                    {{$t('prepaid.group.card.modal.delete')}}
                 </template>
            <p class="my-4">{{$t('prepaid.group.card.modal.delete')}}?</p>
        </b-modal>

         <b-modal centered
                 id="prepaidUserModal"
                 ref="prepaidUserModal"
                 hide-header
                 hide-footer
                 body-class="p-0"
                 >
                 <b-container fluid class="prepaidCard noBorder noMargin p-4">
                     <b-row class="mb-2">
                         <b-col cols="8" class="">
                             {{prepaidUser.code2}}
                         </b-col>
                         <b-col
                            class=""
                            cols="2"
                         ><i v-b-modal="'editCard'" user="'prepaidUser'"  @click="sendInfo(prepaidUser)" v-b-popover.hover.right="$t('prepaid.group.buttons.editCard')" class="fas fa-edit"></i></b-col>
                         <b-col 
                            cols="2"
                            float-right
                            class=""
                         >
                         <i v-b-modal="'deleteCard'" user="'prepaidUser'"  @click="sendInfo(prepaidUser)" v-b-popover.hover.right="$t('prepaid.group.buttons.deleteCard')" class="fas fa-trash"></i> 
                         </b-col>
                     </b-row>
                     <hr/>
                     <b-row class="my-2">
                         <b-col cols="12" class="">
                             <b-row>
                                 <b-col offset="2" cols="2" class="flex-center">
                                     <i class="fas fa-user"></i>
                                </b-col>
                                <b-col cols="8">{{prepaidUser.full_name}}
                                </b-col>
                                </b-row>
                             <b-row>
                                 <b-col offset="2" cols="2" class="flex-center">
                                     <i v-b-popover.hover.left="$t('prepaid.group.card.modal.generate.num')" class="fas fa-mobile">
                                         </i>
                                </b-col>
                                <b-col cols="8">{{prepaidUser.phone}}
    
                                </b-col>
                                
                            </b-row>
                             <b-row>
                                 <b-col offset="2" cols="2"  class="flex-center">
                                     <i v-b-popover.hover.left="$t('prepaid.group.card.modal.generate.dob')" class="fas fa-calendar-day">
                                    </i>
                                </b-col>
                                <b-col cols="8">{{prepaidUser.dob | moment('DD.MM.YYYY')}}

                                </b-col>

                            </b-row>
                         </b-col>
                     </b-row>
                     <hr/>
                     <b-row class="mt-2 text-center" >
                                 <b-col cols="4" >{{prepaidUser.desc}}</b-col>
                                <b-col cols="4" >{{ $t('ticket_scan.row') }}: {{prepaidUser.pref_row}}</b-col>
                                <b-col cols="4" >{{ $t('ticket_scan.seat') }}: {{prepaidUser.pref_seat}}</b-col>
                     </b-row>

                 </b-container>
        </b-modal>

        <b-modal centered
                 no-close-on-backdrop
                 id="editCard"
                 title="Edit current card"
                 class="modal"
                 hide-footer>
                  <template v-slot:modal-title>
                    {{$t('prepaid.group.card.modal.edit.card')}}
                </template>
            <b-form @submit.prevent="editCard()" data-vv-scope="editCard">

                <b-row>

                    <b-col cols="6" class="flex-center">
                        <h5>{{ group.name }}</h5>
                    </b-col>

                    <b-col cols="6">
                        <b-form-group label-for="prepaidGroup">{{$t('prepaid.title')}}
                            <b-form-input :state="validateState('editCard.prepaidGroup')"
                                          :class="{'is-invalid': veeErrors.has('editCard.prepaidGroup')}"
                                          v-validate="'required|min_value:1'" v-model="group.id"
                                          id="prepaidGroup" ref="prepaidGroup" type="number" size="md" name="prepaidGroup" disabled></b-form-input>
                            <span class="vvError">{{ veeErrors.first('editCard.prepaidGroup') }}</span>
                        </b-form-group>
                    </b-col>

                    <b-col cols="6">
                        <b-form-group label-for="fullName">{{$t('prepaid.group.card.modal.generate.name')}}
                            <b-form-input :state="validateState('editCard.fullName')"
                                          :class="{'is-invalid': veeErrors.has('editCard.fullName')}"
                                          v-model="selectedCard.full_name" v-validate="'required|min:6'" id="fullName" ref="fullName" type="text" size="md" name="fullName"></b-form-input>
                            <span class="vvError">{{ veeErrors.first('editCard.fullName') }}</span>
                        </b-form-group>
                    </b-col>

                    <b-col cols="6">
                        <b-form-group label-for="dob">{{$t('prepaid.group.card.modal.generate.dob')}}
                            <date-picker format="YYYY-MM-DD HH:mm:ss"
                                         name="dob"
                                         v-validate="'required'"
                                         v-model="selectedCard.dob"
                                         :not-after="new Date()"
                                         :lang="$parent[$i18n.locale]"
                                         type="datetime"
                                         :minute-step="10"
                                         :first-day-of-week="1"
                                         class="w-100"
                                         id="dob">
                            </date-picker>
                            <span class="vvError">{{ veeErrors.first('editCard.dob') }}</span>
                        </b-form-group>
                    </b-col>

                    <b-col cols="6">
                        <b-form-group label-for="description">{{$t('prepaid.group.card.modal.generate.desc')}}
                            <b-form-input :state="validateState('editCard.description')"
                                          :class="{'is-invalid': veeErrors.has('editCard.description')}"
                                          v-model="selectedCard.desc" v-validate="'required|min:6'" id="description" ref="description" type="text" size="md" name="description"></b-form-input>
                            <span class="vvError">{{ veeErrors.first('editCard.description') }}</span>
                        </b-form-group>
                    </b-col>

                    <b-col cols="6">
                        <b-form-group label-for="phone">{{$t('prepaid.group.card.modal.generate.num')}}
                            <b-form-input :state="validateState('editCard.phone')"
                                          :class="{'is-invalid': veeErrors.has('editCard.phone')}"
                                          v-model="selectedCard.phone" v-validate="'required|min:6'" id="phone" ref="phone" type="text" size="md" name="phone"></b-form-input>
                            <span class="vvError">{{ veeErrors.first('editCard.phone') }}</span>
                        </b-form-group>
                    </b-col>

                    <b-col cols="6">
                        <b-form-group label-for="cardCode">{{$t('prepaid.group.card.modal.generate.code')}}
                            <b-form-input :state="validateState('editCard.cardCode')"
                                          :class="{'is-invalid': veeErrors.has('editCard.cardCode')}"
                                          v-model="selectedCard.code" v-validate="'required|alpha_num'" id="cardCode" ref="cardCode" type="text" size="md" name="cardCode"></b-form-input>
                            <span class="vvError">{{ veeErrors.first('editCard.cardCode') }}</span>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group label-for="cardCode2">{{$t('prepaid.group.card.modal.generate.code2')}}
                            <b-form-input :state="validateState('editCard.cardCode2')"
                                          :class="{'is-invalid': veeErrors.has('editCard.cardCode2')}"
                                          v-model="selectedCard.code2" v-validate="'required|alpha_num'" id="cardCode2" ref="cardCode2" type="text" size="md" name="cardCode2"></b-form-input>
                            <span class="vvError">{{ veeErrors.first('editCard.cardCode2') }}</span>
                        </b-form-group>
                    </b-col>

                    <b-col cols="4">
                    <b-form-group label-for="prefSector">{{$t('prepaid.group.card.modal.generate.sector')}}
                        <b-form-select v-model="selectedCard.pref_sector_id" name="prefSector" v-validate="'required|alpha_num'">
                            <option v-for="sector in sectors" :value="sector.id">{{sector.code}}</option>
                        </b-form-select>
                        <span class="vvError">{{ veeErrors.first('editCard.prefSector') }}</span>
                    </b-form-group>
                </b-col>

                    <b-col cols="4">
                        <b-form-group label-for="prefRow"
                                      v-for="sector in sectors"  v-if="sector.id === selectedCard.pref_sector_id">{{$t('prepaid.group.card.modal.generate.row')}}
                            <b-form-input :state="validateState('editCard.prefRow')"
                                          :class="{'is-invalid': veeErrors.has('editCard.prefRow')}"
                                          v-model.number="selectedCard.pref_row" v-validate="'required|min_value:1|max_value:'+sector.rows" id="prefRow" ref="prefRow" type="number" size="md" name="prefRow"></b-form-input>
                            <b-form-text id="row-help-block" v-for="sector in sectors" v-if="sector.id === selectedCard.pref_sector_id">
                                {{$t('prepaid.group.card.modal.generate.of')}} {{ sector.rows }}
                            </b-form-text>
                            <span class="vvError">{{ veeErrors.first('editCard.prefRow') }}</span>
                        </b-form-group>
                    </b-col>

                    <b-col cols="4">
                        <b-form-group label-for="prefSeat"
                                      v-for="sector in sectors"  v-if="sector.id === card.pref_sector_id">{{$t('prepaid.group.card.modal.generate.seat')}}
                            <b-form-input :state="validateState('editCard.prefSeat')"
                                          :class="{'is-invalid': veeErrors.has('editCard.prefSeat')}"
                                          v-model.number="card.pref_seat" v-validate="'required|min_value:1|max_value:'+sector.row_seats" id="prefSeat" ref="prefSeat" type="number" size="md" name="prefSeat"></b-form-input>
                            <b-form-text id="seat-help-block" v-for="sector in sectors" v-if="sector.id === card.pref_sector_id">
                                {{$t('prepaid.group.card.modal.generate.of')}} {{ sector.row_seats }}
                            </b-form-text>
                            <span class="vvError">{{ veeErrors.first('editCard.prefSeat') }}</span>
                        </b-form-group>
                    </b-col>



                </b-row>

                <b-row>
                    <b-col cols="12" class="text-center">
                        <b-btn type="submit" :disabled="veeErrors.any('editCard')" ref="btnEdit" variant="primary" class="w-50">{{$t('prepaid.group.card.modal.edit.button')}}</b-btn>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>

         <b-modal centered
                 id="deleteCard"
                 title="Confirmation"
                 @ok="deleteCard"
                 ok-variant="danger"
                 >
                   <template v-slot:modal-title>
                    {{$t('prepaid.group.card.modal.delTitle')}}
                </template>
            <p class="my-4">{{$t('prepaid.group.card.modal.delete')}}</p>
        </b-modal>


    </b-container>
</template>

<script>
    // @ is an alias to /src

    export default {
        name: 'prepaidGroup',
        data() {
            return {
                group: {},
                selectedCard: {},
                prepaidUser: {},
                printError: ('toast.printError'),
                card:{
                    id: 0,
                },
                prepaidCards: [],
                cardFields: [
                    {
                        key: 'full_name',
                        labelPath: 'table.prepaid.name',
                        sortable: true
                    },
                    {
                        key: 'dob',
                        labelPath: 'table.prepaid.dob',
                        sortable: true,
                        thClass: 'd-none d-lg-table-cell',
                        tdClass: 'd-none d-lg-table-cell' ,
                        formatter: (value) => this.$moment(value).format("DD.MM.YYYY.")
                    },
                ],
                actions: {
                    detail: {
                        name: 'hover.detail',
                        icon: 'fas fa-id-card'
                    }
                },
                generatedCard: {},
                sectors: null,
            }
        },
        methods: {
            
            validateState(ref) {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref)
                }
                return null
            },
             sendInfo(item) {
                this.selectedCard = item;
            },
            editCard(){
                this.$axios.post('prepaid/updateByCardId',{
                    params: {
                        id: this.selectedCard.prepaid_group_id,
                        card: this.selectedCard
                    }
                }).then(response => {
                    if(response.data.success) {
                        this.$toasted.global.success({
                            message : this.$t(response.data.data.msg)
                        });
                        this.$root.$emit('bv::hide::modal', 'editCard');
                    }else{
                        this.$toasted.global.err({
                            message : this.$t(response.data.data.msg)
                        });
                    }
                });
            },
            deleteCard(){
                this.$axios.post('prepaid/deleteByCardId',{
                        params: {
                            id: this.selectedCard.prepaid_group_id,
                            card: this.selectedCard
                        }
                    }
                ).then(response => {
                    if(response.data.success) {
                        this.$toasted.global.success({
                            message : this.$t(response.data.data.msg)
                        });
                        this.$router.push('/prepaid/' + this.selectedCard.prepaid_group_id);
                        this.$root.$emit('bv::hide::modal','prepaidUserModal' );
                    }
                });
            },
            editGroup(){
                this.$axios.post('prepaid/updateById',
                    this.group
                ).then(response => {
                    if(response.data.success) {
                        this.$toasted.global.success({
                            message : this.$t(response.data.data.msg)
                        });
                        this.$root.$emit('bv::hide::modal', 'editGroup', '#btnEdit');
                    }
                }).then(()=> {
                        this.$nextTick(() => {
                            this.veeErrors.clear();
                            this.$nextTick(() => {
                                this.$validator.reset();
                            });
                        });
                    }
                );
            },
            deleteGroup(){
                this.$axios.post('prepaid/deleteById',
                    this.group
                ).then(response => {
                    if(response.data.success) {
                        this.$toasted.global.success({
                            message : this.$t(response.data.data.msg)
                        });
                        this.$router.push('/prepaid')
                    }else{
                        this.$toasted.global.err({
                            message : this.$t(response.data.data.msg)
                        });
                    }
                });
            },
            generateCard(){
                this.$validator.validateAll('generateCard').then((result) => {
                    if (!result) {
                        this.$toasted.global.err({
                            message : this.$t(this.printError)
                        });
                    }else{
                        this.$axios.post('prepaid/generateCard', {
                                params: {
                                    group: this.group,
                                    card: this.card
                                }
                            }
                        ).then(response => {
                            if(response.data.success) {
                                this.generatedCard = response.data.data;
                                this.$root.$emit('bv::hide::modal', 'generateCard', '#btnGenerate');
                                this.card = {
                                    id: 0,
                                };
                                this.$toasted.global.success({
                                    message : this.$t(response.data.data.msg)
                                });
                            }else{
                                this.$toasted.global.err({
                                    message : this.$t(response.data.data.msg)
                                });
                            }
                        }).then(()=> {
                                this.$nextTick(() => {
                                    this.veeErrors.clear();
                                    this.$nextTick(() => {
                                        this.$validator.reset();
                                    });
                                });
                            }
                        );
                    }
                });
            },
            getSectors(){
                this.$axios.get('sectors').then(response => {
                    if (response.status === 200) {
                        this.sectors = response.data.data;
                    }
                })
            },
            getPrepaidCards(){
                this.$axios.get('prepaid/getCardsByGroupId',{
                        params: {
                            id: this.$route.params.id,
                        }
                    }
                ).then(response => {
                    if (response.status === 200) {
                        this.prepaidCards = response.data.data;
                    }
                })
            },
            goToPrepaidCard(id){
                this.$router.push('/prepaid/card/' + id)
            },
            detailModal(item){
                this.prepaidUser = item;
                this.$refs.prepaidUserModal.show();
            },
            action: function (action, item) {
                switch (action) {
                    case 'detail':
                        this.detailModal(item);
                        break;
                }
            },
        },

        created() {
            this.$axios.get('/prepaid/getById',
                {
                    params: {
                        id: this.$route.params.id,
                    }
                }
            ).then(response => {
                if (response.status === 200) {
                    this.group = response.data.data;
                }
            });
            this.getSectors();
            this.getPrepaidCards();
            let self = this;
            this.interval = setInterval(function () {
                self.getSectors();
                self.getPrepaidCards();
            }, 3000);
        },
        destroyed(){
            clearInterval(this.interval);
        },
    };
</script>
<style lang="scss">
    #prepaidUserModal___BV_modal_content_{
        
    }

    .prepaidCard{
        background-image: linear-gradient( 108deg,  rgba(2,93,145,1) 17.3%, rgba(0,156,222,1) 77.6% )  !important;
        border: 1 solid  rgba(2,93,145,1) 17.3%;
        color: white;
    }
</style>
